import CreateNotificationPage from "./CreateNotificationPage";

export default CreateNotificationPage;
